import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { LinkElement } from '@els/els-react--link-element';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ViewFullPatentFamily from '@Containers/PatentFamilyClustering/Components/ViewFullPatentFamily';
import useExpandPatentFamilyGroupFromBreadcrumb from '@Containers/PatentFamilyClustering/hooks/useExpandPatentFamilyGroupFromBreadcrumb';

function PatentFamilyHeading({
  metadata,
  document,
  title,
  language,
  offices,
  viewFullPatentFamily,
  mainDocumentFirstSectionExpanded,
  onFamilyGroupTitleClick,
  getTrackingAttrs,
  headingId,
}) {
  const displayViewFullPatentFamilyLink = !useExpandPatentFamilyGroupFromBreadcrumb({ document, metadata });

  return (
    <div className="patent-family-heading u-els-padding-bottom-3o4 u-els-margin-bottom-3o4">
      <LinkElement
        href="#"
        data-e2e="patent-family-title"
        navigation
        onClick={onFamilyGroupTitleClick}
        className={cn('patent-family-heading__title-button', {
          'patent-family-heading__title-button--first-section-expanded': mainDocumentFirstSectionExpanded,
        })}
        {...getTrackingAttrs({
          'data-tracking': !mainDocumentFirstSectionExpanded,
          'data-tracking-type': 'contentlinkclick',
          'data-tracking-action': 'title',
        })}>
        {title ? (
          <InnerHTML tag="h3" id={headingId} className="patent-family-heading__title u-els-font-family-serif" html={title} />
        ) : (
          <span id={headingId} className="patent-family-heading__title u-els-font-family-serif">
            No title
          </span>
        )}
      </LinkElement>
      <div className="patent-family-heading__offices-row">
        {language ? (
          <div className="patent-family-heading__offices">
            <span>Language:&nbsp;</span>
            <span className="patent-family-heading__offices-list" aria-label="Patent language">
              {language}
            </span>
          </div>
        ) : null}

        {offices ? (
          <div className="patent-family-heading__offices">
            <span>{`Office${offices.length > 1 ? 's' : ''}:`}&nbsp;</span>
            <ul className="patent-family-heading__offices-list" aria-label="Patent Offices">
              {offices.map((office, index) => (
                <li key={office}>
                  {office}
                  {index < offices.length - 1 && <>,&nbsp;</>}
                </li>
              ))}
            </ul>
          </div>
        ) : null}

        {displayViewFullPatentFamilyLink && (
          <ViewFullPatentFamily metadata={metadata} document={document} viewFullPatentFamily={viewFullPatentFamily} />
        )}
      </div>
    </div>
  );
}

PatentFamilyHeading.propTypes = {
  metadata: MetadataPropTypesShape,
  document: PropTypes.object.isRequired,
  title: PropTypes.string,
  language: PropTypes.string,
  offices: PropTypes.array,
  viewFullPatentFamily: PropTypes.func.isRequired,
  mainDocumentFirstSectionExpanded: PropTypes.bool,
  onFamilyGroupTitleClick: PropTypes.func.isRequired,
  getTrackingAttrs: PropTypes.func.isRequired,
  headingId: PropTypes.string,
};

export default PatentFamilyHeading;
